import { IFRAME_AND_CONTAINER_IDS } from "../../constants";
import { loadIframe } from "../../utils";
import { IFrameSrcGetter } from "./utils";
import { initializeScrollSaver } from "../../ScrollSaver";

export const loadSearchResultsComponent = () => {
    const { searchResults } = IFRAME_AND_CONTAINER_IDS;
    const { containerId } = searchResults;
    const container = document.getElementById(containerId);
    if (!container) return;
    const iFrameSrcGetter = new IFrameSrcGetter();
    const { iframeSrc, iframePath } = iFrameSrcGetter.get();
    loadIframe({
        src: iframeSrc,
        iframeAndContainerIds: searchResults,
    });
    initializeScrollSaver(iframePath);
};
